import { z } from "zod";

export const fullNameSchema = z.object({
  firstName: z.string().min(1, "First Name is required."),
  lastName: z.string().min(1, "Last name is required."),
});
